import React from "react";
import "./OurVision.css";

const OurVision = () => {
  return (
    <div className="vision-container">
      <div className="vision-content">
        <h1>Our Vision</h1>
        <p>
          To meet the growing demand of the maintenance & cleaning industry with
          the latest art of technology in order to satisfy our customer requirements. 
          We see ourselves as the leading provider of total housekeeping & maintenance 
          solutions, improving and enhancing the productivity of housekeeping services 
          at hotels, hospitals, malls, retail corporate offices, and commercial facilities.
        </p>
      </div>
    </div>
  );
};

export default OurVision;
